import axios from "axios";

const BASE_URL =
    process.env.REACT_APP_API_URL;

// =================================
// GET POSTPAID APPROVAL USERS
// =================================

export const getPostpaidApprovals =
    async (token) => {

        try {

            const response =
                await axios.get(
                    `${BASE_URL}/subscription/api/admin/postpaid/approvals`,
                    {
                        headers: {
                            "Content-Type":
                                "application/json",

                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            return response.data;

        } catch (error) {

            console.error(
                "GET Postpaid Approvals Error:",
                error
            );

            throw error;
        }
    };

export const getAllUsers = async (
    token
) => {
    try {

        const response =
            await axios.get(
                `${BASE_URL}/subscription/api/admin/getallusers`,
                {
                    headers: {
                        "Content-Type":
                            "application/json",
                        Authorization:
                            `Bearer ${token}`,
                    },
                }
            );

        return response.data;

    } catch (error) {

        console.error(
            "GET All Users Error:",
            error
        );

        throw error;
    }
};


export const getAllFoodOrdersAPI =
    async (signal) => {
        try {
            const token =
                localStorage.getItem(
                    "authToken"
                );

            const headers =
                token
                    ? {
                        Authorization:
                            `Bearer ${token}`,
                    }
                    : {};

            const response =
                await fetch(
                    `${BASE_URL}/food/api/orders`,
                    {
                        headers,

                        signal,
                    }
                );

            if (!response.ok) {
                throw new Error(
                    `HTTP error! status: ${response.status}`
                );
            }

            const data =
                await response.json();

            return Array.isArray(data)
                ? data
                : [];

        } catch (error) {
            console.error(
                "❌ Fetching food orders error:",
                error
            );

            throw error;
        }
    };